import React, { useCallback, useState } from 'react'
import { Box, Button, Container, IconButton, Typography } from '../imports/muiImport'
import { NavLink, useNavigate } from 'react-router-dom';

import Login from './authPages/Login';
import OTPComponent from './otp/OTPComponent';
import { verifyUserOTPForLogin } from '../mobile/mobileComponents/mobileUserAccountLogin/userAccoountHook';
import { actionNotifier } from '../components/tostify';
import { userTokenSave } from '../apiCalls/functions';
import { useAuth } from '../hooks/contexts/AuthContext';
import Timer from '../pages/LOGIN_SIGNUP/OTP/Timer';
import { validateOtp } from '../apiCalls/urls/urlFunction';
import { Helmet } from 'react-helmet-async';
import BasicBtn from '../components/button/BasicBtn';
import { getCampaignRedirectUrl, clearCampaignRedirectUrl } from '../shared/campaignTracker';

const LoginPage = () => {
  const [showOTPForm, setOTPForm] = useState(false);
  const [isResendAvailable, setIsResendAvailable] = useState(false);
  const [otpFormLoading, setOtpFormLoading] = useState(false);
  const [isResetOtp, setIsResetOtp] = useState(false);
  const [isUserAuthentic, setIsUserAuthentic] = useState({});
  const [otpFormTimer, setOtpFormTimer] = useState(15);
  const [noOfUserOTPSend, setNoOfUserOTPSend] = useState(0);

  const { authUser, setAuthUser, isLoggedIn, setIsLoggedIn } = useAuth();
  const navigate = useNavigate();


  const handleOtpVerify = async (user_phone, user_otp) => {
    setOtpFormLoading(true);
    const loginResponse = await verifyUserOTPForLogin(user_phone, user_otp);
    if (loginResponse?.status) {
      actionNotifier.success(loginResponse?.data?.message, { position: "top-left", autoClose: 2000 });

      if (isUserAuthentic?.isLoginForm && loginResponse?.data?.data) {
        const targetUrl = getCampaignRedirectUrl() || '/';
        userLoginSuccessfully(loginResponse?.data?.data);
        setTimeout(() => {
          clearCampaignRedirectUrl();
          navigate(targetUrl, { replace: true });
          setOtpFormLoading(false);
        }, 300);
      } else {
        setTimeout(() => {
          navigate('/login', { replace: true });
          setOtpFormLoading(false);
          setIsResetOtp(true);
        }, 300);
      }
    } else {
      setOtpFormLoading(false);
      setIsResetOtp(true);
    }
  }

  const handleOtpResend = async (mobile) => {
    if (isResendAvailable) {
      const response = await validateOtp(
        mobile,
        {
          'reason': "Login_resend"
        }
      );
      if (response?.status) {
        setNoOfUserOTPSend((prevState) => prevState + 1);
        setOtpFormTimer(() => 15);

        actionNotifier.info("OTP has been resent", { position: "top-left", autoClose: 1000 });
      }
    } else {
      actionNotifier.warning(`Please wait for the timer to resend OTP`, { position: "top-left", autoClose: 1000 });
    }
  }

  const userLoginSuccessfully = async (token) => {

    let loginToken = userTokenSave(token);

    if (loginToken) {
      // Set true User Login Status it will reflect every where
      setIsLoggedIn(true);

      // Notification remove
      actionNotifier.clearAll();
      const targetUrl = getCampaignRedirectUrl() || '/';
      clearCampaignRedirectUrl();
      navigate(targetUrl, { replace: true });
    }
  }

  const timerEnd = () => {
    if (noOfUserOTPSend <= 2) {
      setIsResendAvailable(() => true);
      setOtpFormTimer(() => null);
      setOtpFormLoading(false);
    } else {
      setOtpFormLoading(false);
      setIsResetOtp(true);
      setIsResendAvailable(() => false);
      window.location.reload();
    }
  }


  return (
    <>
      {!showOTPForm ?
        <>
          <Login
            setOTPForm={setOTPForm}
            setIsUserAuthentic={setIsUserAuthentic}
          />

          <Box sx={{}}>
            <NavLink to={'/password-reset'} style={{ textDecoration: "none" }}>
              <Typography variant='subtitle1'
                sx={{
                  color: "secondary.main",
                  fontWeight: 500,
                  textAlign: 'right',
                  mt: 0.5,
                  mb: 1,
                }}
              >
                Forgot Password ?
              </Typography>
            </NavLink>

            <Typography variant='subtitle1'
              sx={{
                color: "textPrimary.main",
                fontWeight: 400,
                mb: 2,
                textAlign: 'center',
              }}
            >
              Don't have an account?
            </Typography>

            <Button
              variant="outlined"
              fullWidth
              aria-label="Navigate to Sign Up page"
              sx={{
                borderRadius: 6,
                py: 1,
                fontWeight: 600,
                fontSize: '1.125rem',
                color: 'secondary.main',
                borderColor: 'secondary.main',
                textTransform: 'none', // optional: to keep "Sign Up" casing
              }}
              onClick={() => navigate('/signup', { replace: true })}
            >
              Sign Up
            </Button>
          </Box>
        </>
        :
        <>
          <OTPComponent
            phone={isUserAuthentic?.mobile}
            purpose="Login OTP"
            loading={otpFormLoading}
            isResendAvailable={isResendAvailable}
            onVerifyOtp={handleOtpVerify}
            onResendOtp={handleOtpResend}
            isResetOtp={isResetOtp}
            className={'login-verify-otp'}
          />
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",

            }}
          >
            <Timer
              initialTime={otpFormTimer}
              timeEnd={timerEnd}
              timerStyle={{}}
            />
          </Box>
        </>
      }
    </>
  )
}

export default LoginPage
